// import React, { useEffect, useState, useMemo } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import { Modal, Button, Form } from "react-bootstrap";
// import { URL } from "../../../config"; // adjust path if needed
// import Navbar from "../../../Components/Navbar";
// import Loader from "../../../Components/LoaderSpin/Loader";
// import { useTranslation } from "react-i18next";
// import "./reportIssue.css";

// const ISSUE_OPTIONS = [
//   { value: "service_quality", label: "Service quality issue" },
//   { value: "behavior", label: "Inappropriate behavior" },
//   { value: "overcharge_or_payment", label: "Payment / Overcharge problem" },
//   { value: "late_or_no_show", label: "Late arrival / No-show" },
//   { value: "safety", label: "Safety concern" },
//   { value: "lost_item", label: "Lost item" },
//   { value: "damage", label: "Damage to property" },
//   { value: "other", label: "Other" },
// ];

// export default function ReportIssue() {
//   const { t } = useTranslation();
//   const { orderNumber } = useParams(); // from route /support/report/:orderNumber
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [order, setOrder] = useState(null);
//   const [serviceType, setServiceType] = useState(location.state?.serviceType || "");
//   const [loading, setLoading] = useState(false);

//   // form
//   const [issueType, setIssueType] = useState("");
//   const [subject, setSubject] = useState("");
//   const [description, setDescription] = useState("");
//   const [lostItemName, setLostItemName] = useState("");
//   const [lostItemDetails, setLostItemDetails] = useState("");
// //   const [lossValueEstimate, setLossValueEstimate] = useState("");

//   const [showSuccess, setShowSuccess] = useState(false);

//   const theme = useMemo(() => ({
//     primary: "#4361ee",
//     warn: "#f59e0b",
//     bg: "#f8fafc",
//     text: "#1f2937",
//   }), []);

//   useEffect(() => {
//     async function load() {
//       try {
//         setLoading(true);
//         // We need userId to call the filtered /user/:id/orders?orderNumber=...
//         const token = localStorage.getItem("token");
//         const decoded = jwtDecode(token);
//         const userId = decoded.Id.startsWith("user-")
//           ? decoded.Id.split("user-")[1]
//           : decoded.Id;

//         // Get the order details (same endpoint you use in OrderDetailsView)
//         const resp = await fetch(`${URL}/user/${userId}/orders?orderNumber=${orderNumber}`);
//         if (resp.ok) {
//           const arr = await resp.json();
//           if (arr?.length) {
//             setOrder(arr[0]);
//             if (!serviceType) setServiceType(arr[0].service_name);
//           }
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     }
//     load();
//   }, [orderNumber, serviceType]);

//   const servitorName = order?.Servitor
//     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//     : t("reportIssue.noServitor") || "No servitor assigned";

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     if (!issueType) return;

//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");

//       const payload = {
//         orderNumber,
//         serviceType,
//         issueType,
//         subject: subject?.trim() || null,
//         description: description?.trim() || null,
//         lostItemName: issueType === "lost_item" ? lostItemName?.trim() || null : null,
//         lostItemDetails: issueType === "lost_item" ? lostItemDetails?.trim() || null : null,
//         // lossValueEstimate: issueType === "lost_item" && lossValueEstimate ? Number(lossValueEstimate) : null,
//       };

//       const resp = await fetch(`${URL}/reports`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           ...(token ? { Authorization: `Bearer ${token}` } : {}),
//         },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         setShowSuccess(true);
//       } else {
//         const txt = await resp.text();
//         console.error("Report submit failed:", txt);
//         alert(t("reportIssue.submitFailed") || "Failed to submit the report.");
//       }
//     } catch (e) {
//       console.error(e);
//       alert(t("reportIssue.submitError") || "Error while submitting the report.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Loader show={loading} />
//       <Navbar />
//       <div className="RI-page" style={{ background: theme.bg }}>
//         <div className="RI-card">
//           <div className="RI-head">
//             <div className="RI-title">
//               <i className="fas fa-life-ring" />
//               <span>{t("reportIssue.title") || "Help & Support"}</span>
//             </div>
//             <div className="RI-subtitle">
//               {t("reportIssue.subtitle") || "Don’t worry — we’re with you. Share what happened and we’ll take action."}
//             </div>
//           </div>

//           {/* Order recap */}
//           <div className="RI-orderBox">
//             <div className="RI-orderRow">
//               <span className="RI-k">{t("reportIssue.orderNumber") || "Order Number"}</span>
//               <span className="RI-v">#{orderNumber}</span>
//             </div>
//             <div className="RI-orderRow">
//               <span className="RI-k">{t("reportIssue.serviceType") || "Service"}</span>
//               <span className="RI-v">{serviceType || "-"}</span>
//             </div>
//             <div className="RI-orderRow">
//               <span className="RI-k">{t("reportIssue.servitor") || "Servitor"}</span>
//               <span className="RI-v">{servitorName}</span>
//             </div>
//           </div>

//           {/* Form */}
//           <form className="RI-form" onSubmit={onSubmit}>
//             <Form.Group className="mb-3">
//               <Form.Label>{t("reportIssue.issueType") || "What happened?"}</Form.Label>
//               <Form.Select value={issueType} onChange={(e) => setIssueType(e.target.value)} required>
//                 <option value="">{t("reportIssue.selectPlaceholder") || "Select an option"}</option>
//                 {ISSUE_OPTIONS.map(opt => (
//                   <option key={opt.value} value={opt.value}>{opt.label}</option>
//                 ))}
//               </Form.Select>
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>{t("reportIssue.subject") || "Subject (optional)"}</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder={t("reportIssue.subjectPh") || "Short title"}
//                 value={subject}
//                 onChange={(e) => setSubject(e.target.value)}
//               />
//             </Form.Group>

//             {issueType === "lost_item" && (
//               <div className="RI-lostSection">
//                 <div className="RI-lostTitle">
//                   <i className="fas fa-box-open" />
//                   <span>{t("reportIssue.lostItem.title") || "Lost item details"}</span>
//                 </div>

//                 <Form.Group className="mb-3">
//                   <Form.Label>{t("reportIssue.lostItem.itemName") || "Item name"}</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder={t("reportIssue.lostItem.itemNamePh") || "e.g., Wallet, Phone, Keys"}
//                     value={lostItemName}
//                     onChange={(e) => setLostItemName(e.target.value)}
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>{t("reportIssue.lostItem.details") || "Item details (optional)"}</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     placeholder={t("reportIssue.lostItem.detailsPh") || "Color, brand, where you last saw it, etc."}
//                     value={lostItemDetails}
//                     onChange={(e) => setLostItemDetails(e.target.value)}
//                   />
//                 </Form.Group>

//                 {/* <Form.Group className="mb-3">
//                   <Form.Label>{t("reportIssue.lostItem.value") || "Estimated value (optional)"}</Form.Label>
//                   <Form.Control
//                     type="number"
//                     min="0"
//                     step="1"
//                     placeholder={t("reportIssue.lostItem.valuePh") || "Tk"}
//                     value={lossValueEstimate}
//                     onChange={(e) => setLossValueEstimate(e.target.value)}
//                   />
//                 </Form.Group> */}
//               </div>
//             )}

//             <Form.Group className="mb-3">
//               <Form.Label>{t("reportIssue.description") || "Describe what happened"}</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={4}
//                 placeholder={t("reportIssue.descriptionPh") || "Give us a brief description…"}
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//               />
//               <div className="RI-hint">
//                 {t("reportIssue.descriptionHint") || "Please avoid sharing sensitive personal info here."}
//               </div>
//             </Form.Group>

//             <div className="RI-actions">
//               <Button
//                 variant="outline-secondary"
//                 onClick={() => navigate(-1)}
//               >
//                 {t("reportIssue.back") || "Back"}
//               </Button>
//               <Button
//                 type="submit"
//                 style={{ backgroundColor: theme.primary, borderColor: theme.primary }}
//               >
//                 {t("reportIssue.submit") || "Submit report"}
//               </Button>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* Success modal */}
//       <Modal show={showSuccess} onHide={() => setShowSuccess(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{t("reportIssue.successTitle") || "Report submitted"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {t("reportIssue.successBody") || "Thanks for letting us know. We’re reviewing your report and will act as soon as possible. We’re sorry about the problem."}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button onClick={() => { setShowSuccess(false); navigate("/profile/orderhistory"); }}>
//             {t("reportIssue.ok") || "OK"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }





import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Modal, Button } from "react-bootstrap";
import { URL } from "../../../config";
import Navbar from "../../../Components/Navbar";
import Loader from "../../../Components/LoaderSpin/Loader";
import { useTranslation } from "react-i18next";
import "./reportIssue.css";

// const ISSUE_OPTIONS = [
//   { value: "service_quality", label: "Service quality issue" },
//   { value: "behavior", label: "Inappropriate behavior" },
//   { value: "overcharge_or_payment", label: "Payment / Overcharge problem" },
//   { value: "late_or_no_show", label: "Late arrival / No-show" },
//   { value: "safety", label: "Safety concern" },
//   { value: "lost_item", label: "Lost item" },
//   { value: "damage", label: "Damage to property" },
//   { value: "other", label: "Other" },
// ];


export default function ReportIssue() {
  const { t } = useTranslation();
  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [order, setOrder] = useState(null);
  const [serviceType, setServiceType] = useState(location.state?.serviceType || "");
  const [loading, setLoading] = useState(false);

  // form
  const [issueType, setIssueType] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [lostItemName, setLostItemName] = useState("");
  const [lostItemDetails, setLostItemDetails] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);


  const ISSUE_OPTIONS = [
    { value: "service_quality", label: t("servitorReport.issue_options.service_quality") },
    { value: "behavior", label: t("servitorReport.issue_options.behavior") },
    { value: "overcharge_or_payment", label: t("servitorReport.issue_options.overcharge_or_payment") },
    { value: "late_or_no_show", label: t("servitorReport.issue_options.late_or_no_show") },
    { value: "safety", label: t("servitorReport.issue_options.safety") },
    { value: "lost_item", label: t("servitorReport.issue_options.lost_item") },
    { value: "damage", label: t("servitorReport.issue_options.damage") },
    { value: "other", label: t("servitorReport.issue_options.other") }
  ];

  const theme = useMemo(
    () => ({
      primary: "#3ac067",
      bg: "#f5f5f5",
      text: "#1f2937",
    }),
    []
  );

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const userId = decoded.Id.startsWith("user-")
          ? decoded.Id.split("user-")[1]
          : decoded.Id;

        const resp = await fetch(`${URL}/user/${userId}/orders?orderNumber=${orderNumber}`);
        if (resp.ok) {
          const arr = await resp.json();
          if (arr?.length) {
            setOrder(arr[0]);
            if (!serviceType) setServiceType(arr[0].service_name);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNumber, serviceType]);

  const servitorName = order?.Servitor
    ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
    : t("reportIssue.noServitor") || "No servitor assigned";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!issueType) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const payload = {
        orderNumber,
        serviceType,
        issueType,
        subject: subject?.trim() || null,
        description: description?.trim() || null,
        lostItemName: issueType === "lost_item" ? lostItemName?.trim() || null : null,
        lostItemDetails: issueType === "lost_item" ? lostItemDetails?.trim() || null : null,
      };

      const resp = await fetch(`${URL}/reports`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      if (resp.ok) {
        setShowSuccess(true);
      } else {
        const txt = await resp.text();
        console.error("Report submit failed:", txt);
        alert(t("reportIssue.submitFailed") || "Failed to submit the report.");
      }
    } catch (e) {
      console.error(e);
      alert(t("reportIssue.submitError") || "Error while submitting the report.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loader show={loading} />
      <Navbar />

      <div className="RI-page" >
        <div className="RI-wrapper">
          {/* Header */}
          <div className="RI-header">
            <div className="RI-title">
              <i className="fas fa-life-ring" />
              <span>{t("reportIssue.title") || "Help & Support"}</span>
            </div>
            <p className="RI-subtitle">
              {t("reportIssue.subtitle") ||
                "Don’t worry — we’re with you. Share what happened and we’ll take action."}
            </p>
          </div>

          {/* Chips */}
          <div className="RI-chips">
            <div className="RI-chip">
              <span className="RI-chip-k">{t("reportIssue.orderNumber") || "Order"}:</span>
              <span className="RI-chip-v">{orderNumber}</span>
            </div>
            <div className="RI-chip">
              <span className="RI-chip-k">{t("reportIssue.serviceType") || "Service"}:</span>
              <span className="RI-chip-v">{serviceType || "-"}</span>
            </div>
            <div className="RI-chip">
              <span className="RI-chip-k">{t("reportIssue.servitor") || "Servitor"}:</span>
              <span className="RI-chip-v">{servitorName}</span>
            </div>
          </div>

          {/* Card + Form (native inputs like servitor) */}
          <div className="RI-card">
            <form className="RI-form" onSubmit={onSubmit}>
              <label>{t("reportIssue.issueType") || "What happened?"}</label>
              <select
                className="ri-input"
                value={issueType}
                onChange={(e) => setIssueType(e.target.value)}
                required
              >
                <option value="">{t("reportIssue.selectPlaceholder") || "Select an option"}</option>
                {ISSUE_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>

              <label>{t("reportIssue.subject") || "Subject (optional)"}</label>
              <input
                className="ri-input"
                type="text"
                placeholder={t("reportIssue.subjectPh") || "Short title"}
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />

              {issueType === "lost_item" && (
                <div className="RI-lostSection">
                  <div className="RI-lostTitle">
                    <i className="fas fa-box-open" />
                    <span>{t("reportIssue.lostItem.title") || "Lost item details"}</span>
                  </div>

                  <label>{t("reportIssue.lostItem.itemName") || "Item name"}</label>
                  <input
                    className="ri-input"
                    type="text"
                    placeholder={t("reportIssue.lostItem.itemNamePh") || "e.g., Wallet, Phone, Keys"}
                    value={lostItemName}
                    onChange={(e) => setLostItemName(e.target.value)}
                  />

                  <label>{t("reportIssue.lostItem.details") || "Item details (optional)"}</label>
                  <textarea
                    className="ri-input ri-textarea--small"
                    rows="3"
                    placeholder={
                      t("reportIssue.lostItem.detailsPh") ||
                      "Color, brand, where you last saw it, etc."
                    }
                    value={lostItemDetails}
                    onChange={(e) => setLostItemDetails(e.target.value)}
                  />
                </div>
              )}

              <label>{t("reportIssue.description") || "Describe what happened"}</label>
              <textarea
                className="ri-input ri-textarea"
                rows="3"
                placeholder={t("reportIssue.descriptionPh") || "Give us a brief description…"}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />

              <div className="RI-actions">
                <button
                  type="submit"
                  className="ri-btn ri-btn-primary"
                  style={{ backgroundColor: theme.primary, borderColor: theme.primary }}
                >
                  {t("reportIssue.submit") || "Submit report"}
                </button>

                <button type="button" className="ri-btn ri-btn-ghost" onClick={() => navigate(-1)}>
                  {t("reportIssue.back") || "Back"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Success modal */}
      <Modal show={showSuccess} onHide={() => setShowSuccess(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: 700 }}>
            {t("reportIssue.successTitle") || "Report submitted"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("reportIssue.successBody") ||
            "Thanks for letting us know. We’re reviewing your report and will act as soon as possible. We’re sorry about the problem."}
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#3ac067", borderColor: "#3ac067" }}
            onClick={() => {
              setShowSuccess(false);
              navigate("/profile/orderhistory");
            }}
          >
            {t("reportIssue.ok") || "OK"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
